import { useL10n } from "@ews/react-localization-context";
import SettingsTextInput from "../../../Settings/SettingsComponents/SettingsTextInput/SettingsTextInput";
import { TooltipIcon } from "../../../ToolTip/useTooltip";
import { useModifySystemSpecification, useSystemSpecification } from "../../../ReactData/system";
import { Form1 } from "@ews/react-data";

const MonitoredObject: React.FC<{ systemId: string; }> = ({ systemId }) =>
{
    const { translate: t } = useL10n();
    const specification = useSystemSpecification(systemId);
    const modifySystemSpecification = useModifySystemSpecification();

    async function saveSystemSpecification(data: Form1)
    {
        await modifySystemSpecification(systemId, data);
    }

    return <>
        <SettingsTextInput
            text={"TRVB_ADDRESS_LABEL"}
            tooltip={<TooltipIcon text={t("TRVB_ADDRESS_DESC")} />}
            inputType={"text"}
            value={specification.monitoredObject?.address}
            onBlur={({ value }) =>
            {
                if (specification.monitoredObject?.address === value) return;
                if (systemId && specification.monitoredObject) {
                    const { description, usage } = specification.monitoredObject;
                    saveSystemSpecification({
                        ...specification,
                        monitoredObject: {
                            address: value,
                            description,
                            usage,
                        },
                    });
                }
            }
            } />
        <SettingsTextInput
            text={"TRVB_DESCRIPTION_LABEL"}
            tooltip={<TooltipIcon text={t("TRVB_DESCRIPTION_LABEL")} />}
            inputType={"text"}
            value={specification.monitoredObject?.description}
            onBlur={({ value }) =>
            {
                if (specification.monitoredObject?.description === value) return;
                if (systemId && specification.monitoredObject) {
                    const { address, usage } = specification.monitoredObject;
                    saveSystemSpecification({
                        ...specification,
                        monitoredObject: {
                            address,
                            description: value,
                            usage,
                        },
                    });
                }
            }
            } />
        <SettingsTextInput
            text={"TRVB_UTILIZATION_LABEL"}
            tooltip={<TooltipIcon text={t("TRVB_UTILIZATION_LABEL")} />}
            inputType={"text"}
            value={specification.monitoredObject?.usage}
            onBlur={({ value }) =>
            {
                if (specification.monitoredObject?.usage === value) return;
                if (systemId && specification.monitoredObject) {
                    const { address, description } = specification.monitoredObject;
                    saveSystemSpecification({
                        ...specification,
                        monitoredObject: {
                            address,
                            description,
                            usage: value,
                        },
                    });
                }
            }
            } />
    </>;
};

export default MonitoredObject;
